import * as React from "react";
import { MoneyDisplayHelper } from "../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { PercentageTextBoxEditor } from "../../../../../../../react-core/Html/PercentageTextBoxEditor";
import { isNullOrEmpty } from "../../../../../../../react-core/Utils/Arrays";
import { User } from "../../../../../../../Wrap/Models/Models/User/User";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { Table } from "../../../../../../Shared/Table/Table";
import { ClientAccountStore, TreasuredAssetsStore, UserStore } from "../../../../../Stroes/Variable";
import { ProductType } from "../../../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { InvestmentSelectionAction } from "../../../../../../Shared/IST/Action/InvestmentSelectionAction";
import { Investment } from "../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/Investment";
import { AssetsToSellFromPP } from "../../Store/PPToProductInstructionStatic";
import { InvestmentDetailsPopupModal } from "../../../Common/InvestmentDetailsPopUp/InvestmentDetailsPopupModal";
import { ProductAllocation } from "../../../../../../../Wrap/Models/Domains/Transfer/Gia/ProductAllocation";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import { SubAccountTypeHelper } from "../../../Common/Helpers/SubAccountTypeHelper";
import { CheckboxEditor } from "../../../../../../../react-core/Html/CheckboxEditor";
import AriaTooltip from "../../../../../../Shared/Tooltip/AriaTooltip";
import { treasureAssetTooltip } from "../../../Sell/Resource/Content";
import { ServiceProposition } from "../../../../../../../Wrap/Constants/Enums/ServiceProposition";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";

interface IPPtoProductBuyAllocationTableProps extends IProcessComponentProps {
    data: ProductAllocation[];
    tableData: AssetsToSellFromPP[];
    totalValue:number;
    onTableDataDelete: (changes, productId)=>void;
    onTreasuredAssetChange: Function;
    checkTreasuredAsset: Array<number>;
}

interface IPPtoProductBuyAllocationState {
    userInfo: User;

    isShowDetailModal: boolean;
    selectedInvestment: Investment;
}

export class PPtoProductBuyAllocationTable extends ProcessComponent<
    IPPtoProductBuyAllocationTableProps,
    IPPtoProductBuyAllocationState
> {
    constructor(props: any) {
        super(props);
        this.state = {
            userInfo: UserStore.getUserInfo(),
            isShowDetailModal: false,
            selectedInvestment: null,
        };
    }

    private onAssetsChanges(row: AssetsToSellFromPP, v: number) {
        const i = this.props.data.findIndex((ele) => ele.ProductId == row.ProductId);
        const _data = this.props.data.concat();
        if (i > -1) {
            _data[i].Percentage = v;
        } else {
            _data.push({Percentage: v, ProductId: row.ProductId });
        }
        this.props.onChange(_data);
    }

    
    private treasureAsset = (v: boolean, code) => {
        const _data: any[] = this.props.tableData.concat();
        const ele = _data.find((ele) => ele.ProductCode == code);

        this.props.onTreasuredAssetChange(v, ele.ProductId);
    };

    isValid() {
        const total = this.props.data?.reduce((sum, curr) => {
            return (sum = sum + curr.Percentage);
        }, 0);
        if (total !== 100) {
            this.props.showErrorMsgPopUp(["Please enter values against the assets to disinvest total 100%."]);
        }
        return super.isValid() && total == 100;
    }

    private onInvestmentSelected(investment) {
        InvestmentSelectionAction.getUnitPrice(investment, (d) => {
            this.setState({ selectedInvestment: d, isShowDetailModal: true });
        });
    }

    private renderInvestmentDetailPopupModal(): JSX.Element {
        const { isShowDetailModal, selectedInvestment } = this.state;

        if (!isShowDetailModal) return null;
        return (
            <>
                <InvestmentDetailsPopupModal
                    showBox={isShowDetailModal}
                    callBack={() => {
                        this.setState({ isShowDetailModal: false });
                    }}
                    instrumentCode={selectedInvestment?.InstrumentCode}
                    productId={selectedInvestment?.ProductId}
                    instrumentName={selectedInvestment?.DisplayName}
                    unitCost={selectedInvestment?.UnitCost}
                    securityType={selectedInvestment?.Type}
                    unitPrice={selectedInvestment?.UnitPrice}
                />
            </>
        );
    }

    public render(): JSX.Element {
        const { data, tableData } = this.props;
        if (tableData.length==0)
            return <Alert alertType={AlertType.Warning} message={"No investments have been selected."} />;
        
        const total = data?.reduce((sum, curr) => {
            return (sum = sum + curr.Percentage);
        }, 0);

        let totalValue = this.props.totalValue;

        if (isNullOrEmpty(tableData)) {
            return null;
        }
        
        let _tableData = tableData.concat();
      
        return (
            <>
                <Table
                    data={_tableData}
                    col={[
                        {
                            title: "Assets",
                            key: "AssetName",
                            thCssWrapper: "cell-left cell-40 pr-0",
                            tdCssWrapper: "cell-left cell-40 pr-0",
                            render: (data, row:AssetsToSellFromPP, index) => {
                                if (
                                    [
                                        ProductType.ManagedModelPortfolio,
                                        ProductType.TailoredModelPortfolio,
                                        ProductType.AdviserModelPortfolio,
                                    ].includes(row.ProductType)
                                )
                                    return data;
                                
                                return (
                                    <a className="hyperlink" onClick={() => this.onInvestmentSelected({ProductCode: row.ProductCode})}>
                                        {data}
                                    </a>
                                );
                            },
                        },
                        {
                            title: "Allocation",
                            key: "ProductId",
                            thCssWrapper: "cell-left cell-15 pr-0",
                            tdCssWrapper: "cell-right cell-15 pr-0",
                            render: (data, row: AssetsToSellFromPP, index) => {
                                const percentage =
                                    this.props.data.find((ele) => ele.ProductId == row.ProductId)?.Percentage || null;
                                return (
                                    <PercentageTextBoxEditor
                                        value={percentage}
                                        onChange={(v) => this.onAssetsChanges(row, v)}
                                        maxNumberOfDecimalPlaces={{
                                            errorMessage: "only allow two decimal places",
                                            value: 2,
                                        }}
                                        validationRules={[
                                            {
                                                errorMessage: "Please enter a value to switch that is less than 100% and equates to less than 100% of the current estimated value of the fund.",
                                                validator: (v) => {
                                                    return v <= 100;
                                                },
                                            }
                                        ]}
                                        infoText={ MoneyDisplayHelper.getMoneyFormat({
                                                      Amount: (percentage || 0) * totalValue * 0.01,
                                                  })
                                        }
                                    />
                                );
                            },
                        },

                        !SubAccountTypeHelper.isLegacyProduct(
                            ClientAccountStore.getClientAccountInfo()?.SubAccounts?.find(
                                (ele) => ele.HierarchyId == getQueryParameters()?.["subaccounthierarchyid"]
                                )?.SubAccountType
                            ) &&
                                ClientAccountStore.getClientAccountInfo()?.AccountServicePropositionId == ServiceProposition.Wrap
                                ? {
                                    title: (
                                        <span>
                                            Protect from auto-disinvestment?
                                            <AriaTooltip cssWrapper="is-info-icon ml-6">{treasureAssetTooltip}</AriaTooltip>
                                        </span>
                                    ),
                                    key: "isTreasuredAsset",
                                    thCssWrapper: "cell-left cell-30 pr-0",
                                    tdCssWrapper: "cell-right cell-30 pr-0",
                                    render: (data, row: AssetsToSellFromPP) => {
                                        if (row.ProductType != ProductType.Cash && row.ProductType != ProductType.CashProduct) {
                                            return (
                                                <CheckboxEditor
                                                    cssWrapper={"square-checkbox mb-0"}
                                                    onChange={(v) => this.treasureAsset(v, row.ProductCode)}
                                                    value={this.props.checkTreasuredAsset?.includes(row.ProductId)}
                                                    disabled={(TreasuredAssetsStore.getTreasuredAssetsProductIds() || [])?.includes(
                                                        row.ProductId
                                                    )}
                                                />
                                            );
                                        } else {
                                            return (
                                                <span>N/A</span>
                                            );
                                        }
                                    },
                                }
                                : null,

                        {
                            title: "Action",
                            key: "Action",
                            thCssWrapper: "cell-right cell-30 pr-0",
                            tdCssWrapper: "cell-right cell-30 pr-0",
                            render: (data, row) => {
                                return (
                                    <button
                                        className="remove-button label-sr-only"
                                        title="Delete"
                                        onClick={() => this.props.onTableDataDelete(-1, row.ProductId)}
                                    >
                                        <span className="icon" aria-hidden="true"></span>
                                        <span className="text">remove</span>
                                    </button>
                                );
                            },
                        }
                    ]}
                    TotalBody={[
                        { data: "Total", colSpan: 1 },
                        {
                            data: (
                                <div style={{ textAlign: 'right' }}>
                                    <span className={total === 100 ? "text-positive" : "text-text"}>
                                        {total}%
                                    </span>
                                </div>
                            ),
                            colSpan: 1,
                        },
                        { data: "", colSpan:2 }
                    ]}
                />
                { this.renderInvestmentDetailPopupModal()}
            </> 
        );
    }
}
